/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Connect_OnedriveInputs */



/**
* | output |
* | --- |
* | "Connect OneDrive" |
*
* @param {Spaces_Connect_OnedriveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_connect_onedrive = /** @type {((inputs?: Spaces_Connect_OnedriveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Connect_OnedriveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit OneDrive verbinden")
	return /** @type {LocalizedString} */ ("Connect OneDrive")
});